import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
  id: '',
};

export const addLinkedinProfile = createAsyncThunk(
  'linkedin/add-profile',
  async ({ data, onSuccess, onError }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/linkedin/add-profile`, data);
      onSuccess && onSuccess(response?.data);
      return response?.data;
    } catch (error) {
      onError && onError(error);
      notification.error({
        message: 'Error',
        description: error?.response?.data?.errors[0]?.message || 'Network error',
      });
      return rejectWithValue(error?.response?.data);
    }
  }
);

const addLinkedinProfileSlice = createSlice({
  name: 'Add Linkedin Profile',
  initialState: initialState,
  reducers: {
    setAddLinkedinProfileIsSuccess: (state, action) => {
      state.isSuccess = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addLinkedinProfile.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
    });
    builder.addCase(addLinkedinProfile.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action?.payload?.success;
      state.message = action?.payload?.message;
      state.id = action?.payload?.id;
    });
    builder.addCase(addLinkedinProfile.rejected, (state, action) => {
      state.isLoading = false;
      state.errors = action.payload?.errors || [];
      state.isError = true;
    });
  },
});

export const { setAddLinkedinProfileIsSuccess } = addLinkedinProfileSlice.actions;

export default addLinkedinProfileSlice?.reducer;
